export var assetsURL = 'https://images.synchronycredit.com';
export var apigeeURL = "https://api-qa.syf.com";
export var config = {
    apiErrorCallback: function () { },
    hosts: {
        apigee: new URL(apigeeURL),
        assets: new URL(assetsURL)
    },
    lang: 'en'
};
//# sourceMappingURL=mfe-config.js.map